// src/pages/Hymns.jsx
import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Chip,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Paper,
  Stack,
  InputAdornment,
  Alert,
  Snackbar,
  CircularProgress,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  useMediaQuery,
  useTheme,
  Fab,
  Zoom,
  Badge
} from '@mui/material';
import {
  Search as SearchIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  MusicNote as MusicNoteIcon,
  MenuBook as MenuBookIcon,
  Close as CloseIcon,
  Print as PrintIcon,
  Share as ShareIcon,
  PlayArrow as PlayIcon,
  Fullscreen as FullscreenIcon,
  KeyboardArrowUp as ArrowUpIcon,
  KeyboardArrowDown as ArrowDownIcon,
  LibraryMusic as LibraryIcon,
  History as HistoryIcon,
  Clear as ClearIcon,
  Bookmark as BookmarkIcon,
  BookmarkBorder as BookmarkBorderIcon
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { db } from '../firebase/config';
import { doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import './Hymns.css';

// Hymnal Data - All hymns from the PDF
const hymnsData = [
  {
    id: 1,
    title: "SABATO",
    number: 1,
    verses: [
      "1.Je watambua sabato ya Bwana, mungu wetu, siku tukufu ya kumwabudu muumba wa mbingu na nchi, kwa siku sita alifanya kazi siku ya saba akapumzika na kuibariki",
      "CHORUS: [siku] Siku ya furaha, yenye mibaraka tele, ilibarikiwa na Mungu hapo mwanzo",
      "2. Tutafurahi kwenye sabato ya ahadi tukiwa na kiongozi Yesu pamoja na malaika wote, na nyimbo tamu za wenye heri tutaziimba kwenye sabato, ile ya ajabu"
    ]
  },
  {
    id: 2,
    title: "TWAWAKARIBISHENI",
    number: 2,
    verses: [
      "1. [Huu ndio wakati wa kurudisha shukrani zetu] kwa yale yote Bwana katutendea [Ametenda makuu yasiyoweza kuelezeka] Ila kwa yote twasema ni asante",
      "Chorus: Tuwawakaribisheni nyote kwa ibada ya Sabato, tukutane naye Mungu atufinyange upya tena.",
      "2. [Huu ndio wakati wa kupokea nguvu za Bwana] hatutaweza kusonga mbele tena [Mbele kuna vikwazo bila uwezo toka kwa Bwana] hatutaweza kumaliza safari"
    ]
  },
  {
    id: 3,
    title: "DAMASKI",
    number: 3,
    verses: [
      "1. Njiani kuenda Damaski kuwatesa wan'ake, (kanifumba macho kanibadili) nikawa mwana wake Yesu ni wa upendo",
      "2. Sikuweza kutosheka wanaume watano (pepo la kuzini kaniingia) kanihurumia kanisafisha ni wa upendo",
      "CHORUS: Njooni mumuone mgeni nisiyemjua ananijua ndani...amenipa fursa ya kubadilika kujiosha nafsi ilochafuka niwe safi"
    ]
  },
  {
    id: 4,
    title: "WAKIWA CHOMBONI",
    number: 4,
    verses: [
      "1. Wakiwa chomboni wakamuona bwana akitembea juu ya maji ndipo akasema Petro bwana ni amuru niende vivyo ivyo juu ya maji (bwana akamuamuru ayatembee) hatua ya kwanza hatua ya pili kaanza kuzama ×2",
      "2. Akiwapo Yesu mambo yote shwari kuna amani teletele mara tukiacha kumtegemea twapata hofu mashaka hutawala (mwite Yesu awe boma la ngome yako) yaliyo magumu hutoweka mara akiwapo Yesu ×2",
      "(Kaenda Kaenda.......hatua kaenda ..... hatua Kaenda.......ooh Akaona shaka..... kidogo.....hatua.....kaanza.....hatua.....kuzama...naa...akalia bwana wangu niokoe Yesu akamrehemu tazame Yeye Mwokozi mwite akuone×2)"
    ]
  },
  {
    id: 5,
    title: "NINAYAWEZA MAMBO YOTE",
    number: 5,
    verses: [
      "Nayaweza yote kwa jina la Yesu mbele yangu naona nuru anaongoza mapito yangu nijibu kwa mashaka yangu sitapungukiwa na chochote anajua shida zangu",
      "1. Ninayaweza mambo yote kwa jina la Yesu nimejifunza kumtumaini siku zote.",
      "2. Furaha amani tunapata kwa jina hili ni mtetezi wangu nikiitwa hukumuni"
    ]
  },
  {
    id: 6,
    title: "JEFTHA",
    number: 6,
    verses: [
      "CHORUS: Mana ka Jeffha adwar tekri, Mana ka jeftha ahop singruokni, Achiwni gigi duto mamagi, Mondo amii nyingi duong.",
      "1. Asebedo jamecho, ngamachayo roudhe, An okachop singruokna, ( to nikech herani (herani) yaye Yesu roudha, imiya thuolo alokra )x2",
      "2. Okadwa bedo, kaka Saphira, Okadwaro tho kaka Achan, ( Wira gi rembi yaye Yesu ruoth nyasacha, mondo amiii nyingi duong )x2"
    ]
  },
  {
    id: 7,
    title: "NI NANI?",
    number: 7,
    verses: [
      "1. Kati ya wale wote wanaomwamini, ni nani atakaye simama, atakayetetea imani, hadi mwisho, mwisho wa dahari je ni...nani?",
      "CHORUS: Vita hivi vinahitaji Imani, Imani imara iliyo dhabiti tegemea Yesu siku zotee, ndiye ngao x2",
      "2. Ndugu na dada zangu, nawasihi nyote, msimame imara kwenye Imani, tegemea Yesu siku zote. Hadi mwisho, mwisho wa safari, mtegemea"
    ]
  },
  {
    id: 8,
    title: "ENYI WANAUME WA GALILI",
    number: 8,
    verses: [
      "1. Enyi wanaume wa Galili mbona mnasumbuka kuangalia juu, (maana alivyo chukuliwa kwenu ata rudi x2)",
      "Msifadhaike enyi msilie kitambo tu kidogo, (kwani yeye aliahidi atarudi, ata timiza x2)",
      "Chorus........ [Soprano: Tarumbeta] Tarumbeta italia italia wafu wote wafufuka, (na machozi) yatafutwa, yatafutwa vigelele zasikika , hakuna huzuni kule ni raha milele na milele",
      "SOLO: Enyi mnao nuru tangaza kote, enyi mliokolewa shikilia Imani... Kamwe tusiishi kama wale... (sop : mafarisayo) wasio na Imani x2"
    ]
  },
  {
    id: 9,
    title: "KANDO KANDO YA BAHARI",
    number: 9,
    verses: [
      "1. Kando kando ya bahari ya shamu walisimama wenye hofu, hawakuwa na imani kwamba watavuka ng'ambo x2",
      "CHORUS: Nyosha fimbo juu ya bahari waja wangu wapate kunusurika, msiangalie farao nalo jeshi lake la kutisha safari yenu ni (mbele) nyuma hamrudi kamwe x2",
      "2.Kweli kweli tunayo safari ya kuenda binguni, japo shida zote zatukumba tusikate tamaa*2"
    ]
  },
  {
    id: 10,
    title: "ENVI WA NYUMBA YA ISRAELI",
    number: 10,
    verses: [
      "1. Envi wa nyumba ya Israeli njooni twende katika nuru ya Bwana hapo ndipo pana pumziko, pumziko la ajabu, tutue mizigo yetu ya dhambi tupate nuru nuru iliyo kweli tuishi na Bwana milele zote",
      "CHORUS: Tukapumzike na Bwana wetu kusimulia kisa cha ukombozi tufutwe machozi na Mungu wetu ni raha ni raha isiyo kifani hapo tutaishi milele zote nachuchumilia wokovu wangu karamu ni washindi walioshinda dhambi natamani niwepo pale.",
      "2. Safari ya matumaini imejaa vikwazo na shida ukituacha Bwana tutaanguka na kupotea dhambini milele nyosha mkono wa rehema utupe nyoyo iliyo safi twataka kuona mji wa Mungu"
    ]
  },
  {
    id: 11,
    title: "TUNEHEMESHE",
    number: 11,
    verses: [
      "1. Bwana mungu twaja mbele zako sisi wakosaji tusamehe tunatenda maovu kila siku eeh bwana utusamehe *2",
      "CHORUS: Twajua sisi wakosaji hatufai mbele zako bwana (tunehemeshe mara nyingine tena tupate kurithi ufalme wako*2)",
      "2. Hatuna pengine pa kukimbilia wewe mshadaa wetu twanyenyekea mbele zako Bwana utupokee leo *2"
    ]
  },
  {
    id: 12,
    title: "TAMBUA",
    number: 12,
    verses: [
      "1. Waliomkubali yesu, aliwapa uweza kuitwa wana wake tena, akawapa nguvu waenda wahubiri kwa kila lugha na jamaa wote, waje kwake, watakao amini na kutubu dhambi wabatizwe kwa maji mengi wote waje kwake X2",
      "CHORUS : Tambua, tambua enendeni mkawafanye mataifa (wote) wanafunzi wangu",
      "2. Jukumu kubwa tumepewa tutangaze injili alituamuru twende kote tuhubiri neno ndipo atarejea maokozi kutuchukua mbinguni"
    ]
  },
  {
    id: 13,
    title: "DHORUBA",
    number: 13,
    verses: [
      "CHORUS : Dhoruba karibu itapita na giza halitadumu[songa] songa [nenda] mbele usitue nanga songa",
      "1. Katika safari hii tumejawa wasiwasi na bwana atuagiza tusitue manga",
      "2. Safari iliyo mbele inayo dhoruba kali ila tuwepo jasiri tutavuka sote"
    ]
  },
  {
    id: 14,
    title: "HAKIKA TUMEPEWA MAMLAKA",
    number: 14,
    verses: [
      "1. Hakika tumepewa mamlaka juu ya viumbe vya dunia shetani hana mamlaka tena kati ya wana wa Mungu baba kanyaga kanyaga kwa ujasiri jina la Kristo lashinda vyote",
      "CHORUS: Mamlaka tumepewa na uwezo tumepewa, tutakanyaga kanyaga mapepo ujira ndugu twaahidiwa tembea tembea wana wa Mungu Kanaani kwetu tutafika",
      "2. Mara tutapofika mbinguni majeraha yote yatapona Bwana Yesu atatupokea tutavikwa mwili wa washindi kanyaga kanyaga kwa ujasiri jina la Kristo lashinda vyote."
    ]
  },
  {
    id: 15,
    title: "KARIBU TUTAONA JIJI",
    number: 15,
    verses: [
      "1. Karibu tutaona jiji tulioahidiwa, msifadhaike moyoni ni mwenu Yesu alitamka, jicho halijapata kuona mazuri ya mbinguni ndugu kaza mwendo tuingie [Bass: pale] katika jiji",
      "CHORUS: Ni shangwe shangwe vigelegele Yesu akiongoza, nuru yake yaongoza kuingia kwenye jiji, itakuwa jubilee ni shangwe juu mbinguni, kaza mwendo tuingie pale katika jiji.",
      "2. Barabara za kwenye jiji zimejaa dhahabu, ni kunyatanyata mwendo wa pole mwendo wa maharusi wakaaji wa jiji lile wamejawa na upendo wenye chuki hawatakuwepo katika jiji"
    ]
  },
  {
    id: 16,
    title: "ALILALA",
    number: 16,
    verses: [
      "1. Alilala pembeni mwa birika, kwa miaka thelathini na nane bila tumaini wala tegemeo Yesu kapita kamsaidia.",
      "CHORUS: Simama uende eeee simama uende [sop : simama leo], akasimama kajitwika godoro lake akaenda",
      "2. Je umelemewa nayo mizigo, na masumbufu ya dunia hii, je umemwamini Yesu Bwana wetu mwambie leo atakusikia"
    ]
  },
  {
    id: 17,
    title: "ITAKUWA FURAHA",
    number: 17,
    verses: [
      "chorus: (Tenor: \"Itakuwa\") Itakuwa furaha kwa watakatifu wote tutakapotembea kuingia yerusalemi kwa shangwe na vifijo tutazikanya njia zile za dhahabu ni sherehe kubwa. x3",
      "1. Mwendo umekuwa mgumu milima mabonde mawe na miiba yatuumiza miguu lakini tukimtazama Yesu anatutia shime, (twendeni mbele kwa pamoja hadi mwisho wake) x2",
      "2.Tunazo habari njema Yesu alishinda ndiye asemaye makao yaandaliwa, kama mkamiini neno langu ushindi ni hakika (huo mji yerusalemi mtauingia) x2"
    ]
  },
  {
    id: 18,
    title: "KARAMU",
    number: 18,
    verses: [
      "1. Karamu ya mwana kondoo imeandaliwa kwa watu wote, Ni neema imetolewa bure bure mimi nawe tuingie pale, kawaambie majirani zako na ndugu zako wasikose siku hiyo",
      "chorus: [Tenor: Rojo] Rojo rojo zimeandaliwa pale kwa ajili yangu mimi na wewe Maombolezo hakuna hata vilio hakuna njaa, (na njaa) Hata magonjwa hakuna ni raha furaha milele zote*2",
      "2. Hebu sema ndugu yangu mikristo kama nia yako ni kuwepo, Karamuni pamoja na Yesu Kristo siku hiyo juu angani, Tayarisha njia zako zote mfalme anakuja Je uko tayari?"
    ]
  },
  {
    id: 19,
    title: "NIACHENI NISEME",
    number: 19,
    verses: [
      "1. Niacheni niseme kama Mungu alivyoniagiza hata wakisema nang'ang'a na huyu Mungu, Mungu ni wangu",
      "chorus:(Tenor: Naomba) Naomba baraka zako Bwana unifundishe niweze kusimama kutetea imani yangu [hata baba na mama wakinacha mimi], [hata marafiki wakiniacha mimi], [hata kaka na dada wakiniacha mimi] siwezi muacha Yesu …",
      "2. Nitakwenda popote pale muumba atapoaniagiza hata wakisema nang'ang'ana na huyu Mungu, Mungu ni wangu.",
      "3. Nitaimba milele na milele kumsifu muumba wangu hata wakisema nang'ang'ana na huyu Mungu, Mungu ni wangu."
    ]
  },
  {
    id: 20,
    title: "SAFARI ILIANZA MISIRI",
    number: 20,
    verses: [
      "1. Safari ilianza misiri ni safari ya matumaini ilisongwa songwa na misuko misuko safari ya mbingu njia ni finyu.",
      "CHORUS: (Na walipofika katika bahari kando ni milima nyuma adui) [Bass: Ee Musa] Nyosha fimbo juu ya bahari waja wangu wapate njia Wote walivuka salama wakaimba nyimbo za shangwe.... maajabu ya mungu ni mengi kwake yote yawezekana katamka na vyote vikawa yeye ni muweza yote×2",
      "2. Safari ingali ya kwenda mbinguni yahitaji uvumilivu shetani aleta majaribu makali tujipe moyo tusirudi nyuma"
    ]
  },
  {
    id: 21,
    title: "SIKU MOJA KATIKA HEKALU",
    number: 21,
    verses: [
      "1. Siku moja katika hekalu lako ni bora kuliko siku elfu na elfu katika shughuli zangu, nami ningependa niwe bawabu katika hekalu lako kuliko kuishi katika hema za uovu.",
      "Chorus: Basi niongoze kila siku Bwana nionyeshe wema na fadhili zako, unifunze Bwana unielekeze, ili niwe mtumishi kwa wanaokuitaji Bwana...",
      "2. Bwana kwa hakika umetenda mema katika maisha yangu siwezi legea kuimba sifa zako Bwana... Nami nahitaji uwepo wako katika maisha yangu niweze kuishi katika hema za wokovux2"
    ]
  },
  {
    id: 22,
    title: "NAAMANI",
    number: 22,
    verses: [
      "1. Mbona unateseka ewe Naamani kama mtu hana matumaini, kule yerusalem i kuna nabii aliyetumwa na Yehova amka sasa wokovu wako umo kule yerusalem",
      "CHORUS: Kaingia mara ya kwanza, mara ya pili, mara ya tatu naamani hakupona kaingia mara ya nne, mara ya tano, mara ya sita naamani hakupona kaingia mara ya saba akatoka yorodani akiwa salama.",
      "2. Mbona unateseka ewe mkristo kama mtu hana matumaini, mbona hujatambua yesu mwokozi azijua shida zetu, piga magoti upate kuomba Mungu akusaidie"
    ]
  },
  {
    id: 23,
    title: "TUNAWAZIA YA ULIMWENGU",
    number: 23,
    verses: [
      "1. Tunawazia ya ulimwengu yaliyojaa machafuko na anasa na huzuni tele ingekuwa vyema tukiwazia ya mbinguni yaletayo furaha lakini ndugu tumepoteza imani, tumekuwa makafiri.",
      "CHORUS: Tuyaache ya dunia yapita tumtazame Mwokozi atuita, ndugu kaza kaza mwendo tuingie mbinguni *2",
      "2. Enyi nawaahidi kwa Baba yangu mna makao mazuri naenda kuwaandalia, Haingekuwa kweli ningewaambia ila nawahakikishia hayo, na wewe ndugu sasa zidisha imani tuingie mbinguni"
    ]
  },
  {
    id: 24,
    title: "SIMAMENI KATIKA NJIA KUU",
    number: 24,
    verses: [
      "Simameni katika njia kuu mkaone mkaulize habari ya mapito mapito ya zamani, (Iwapi njia iliyo njema kaende katika njia hiyo, Lakini walisema hatutaki kuenda katika njia hiyo×2)",
      "Chorus: Bwana nipe nguvu Kama Enoka Kama Eliya wazee wa kaleee... hatua moja mbili kwako nikufuate niweze kupambanua mapenzi yako Bwana, Tengeneza mapito yangu Bwana zaidi zaidi niwe wako ×2",
      "(Sop&alto) Binti Sayuni laiti ungesikiliza, (All) Mbele vita kubwa juu yako oo Rudi nyumbani kwenye njia panda...upate nuru ya uzimaaa, upate raha katika nafsi yako..."
    ]
  },
  {
    id: 25,
    title: "SIWEZI AMINI",
    number: 25,
    verses: [
      "1. Siwezi amini amefufuka toka kaburini na sasa yuko Yerusalemni , ni jambo la kushangaza sana (lazima nione alama ndipo nitaamini amefufuka) ×2",
      "CHORUS: Mwanakondoo ndiye kafara ya mwisho kwa ulimwenguni kwa kifo chake sisi twahesabiwa haki atukuzwe×2",
      "2. [SOLO] Nina ujumbe kwa ulimwengu, Bwana alifufuka yu hai tena, [All] Ewe Tomaso imarisha imani, imani yako, na uamini kwamba Mwokozi ndiye mkombozi."
    ]
  },
  {
    id: 26,
    title: "KWA SABABU BWANA MWENYEWE",
    number: 26,
    verses: [
      "1. Kwa sababu Bwana mwenyewe asema atashuka kutoka mbinguni, Pamoja na mwaliko wake na sauti ya malaika mkuu, Na parapanda ya Mungu na hao waliyo kufa katika Kristo, Nao wote watafufuliwa kwanza X2",
      "Chorus: (Tazama) ×2 Yuaja mawinguni (Alto) Bwana wetu........... kila jicho duniani nzima litamwona, Na hao waliomchoma na kabila zote za dunia Wataomboleza omboleza kwa ajili yake.x2",
      "2. Kisha sisi sote tulio hai tulosalia tutanyakuliwa, Pamoja nao mawinguni tumlaki Bwana hewani. Na hivyo tutakuwa pamoja na Bwana wetu milele, Ni furaha isiyo na kifani x2 *Ref* : *1st Thessalonians 4:16-17 and Revelation 1:7*"
    ]
  },
  {
    id: 27,
    title: "JE NDUGU YANGU",
    number: 27,
    verses: [
      "1. Je ndugu yangu wasumbukia juu ya maisha yako yote yale yajayo na kotekote unazo shida ndugu ambazo huwezi jitatulia...amini amini Mungu yupo wakati wote...amini amini Mungu yu nawe×2",
      "Chorus: Mungu akiwa upande wako tatua tatua tatizo lako, mwamini aweza yote... yote shwari ×2 (Bass-Na mwamini Mungu)",
      "2. Kumbuka mtumishi Ayubu wee mkristo, alivyopitia majaribu mengi...licha ya hayo yote alimwamini Mungu mwishowe akafarijika... Amini Amini Mungu yupo wakati wote, Amini Amini Mungu yu nawe"
    ]
  },
  {
    id: 28,
    title: "ZAKA NA SADAKA",
    number: 28,
    verses: [
      "1. Ziangushe toka mikononi mwenu leo Yesu azipokee zote, zaka na sadaka alizowapa nyinyi nyote zileteni kwake, Kila moja atahesabu awabariki wote wana wake, tambua yote ni mali yake, zileteni usoni pakex2",
      "CHORUS: Leteni zaka sadaka kamili yote ghalani mwa Bwana, na, nyumbani mwake pajae chakula pasiwe na upungufu wowote, asema mjaribu Bwana wa Majeshi atafungua madirisha ya mbinguni, kuwamwagia baraka pasiwe na nafasi ya kutosha×2",
      "2. Ametupa vyote impendezavyo na tena ameahidi kutulindia, anachohitaji kwangu mimi na wewe tuwe wasimamizi wa kweli, tujitenge na tamaa za kumwibia Bwana na yeye hataharibu, mazao yetu katika shamba, laana zote zitatoweka×2"
    ]
  },
  {
    id: 29,
    title: "SAUTI KAMA YA BATIMAYO",
    number: 29,
    verses: [
      "1. Sauti kama ya Batimayo kati ya umati amekemewa anyamaze na anazidi palipo Bwana anyamaze je *2",
      "CHORUS: Mwana wa Daudi Yesu, naomba nione nuru nihurumie Yesu nalemewa sana (oo sana) njiani..... Yesu nifumbue macho hekima za mbingu nipe nitembee nawe niongoze hadi nyumbani",
      "2. Dunia ya giza nimekua naja kwako Bwana unifumbue macho yangu ya kiroho nitembee nuruni Bwana *2"
    ]
  },
  {
    id: 30,
    title: "SEMA NENO",
    number: 30,
    verses: [
      "1. Sema neno Bwana sema leo, jinsi ulivyosema zamani, Bwana tupe roho tupatepona, tujiepushe na maovu yote, sisi wanyonge tena wadhaifu, hatuwezi shindana na ibilisi neno lako ndilo nguzo kwetu, Bwana sema Leo*2",
      "CHORUS: Bwana sema nasi leo, mapepo yote yatoroke, vipofu pia waweze ona, wafu nao wawezefufuka, viwete nao wapate tembea kwa neno lako takatifu, Bwana tupe neno lako liwe nguzo kwetu...",
      "2. Kwa neno lako vyote viliumbwa, kwa neno lako vyote vikawa, kwa neno lako milango ya gereza, ikafunguka wana wako watoka, neno hili walihitaji leo sisi wafungwa kwa minyororo ya shetani tuwe huru kwa neno lako Bwana *2"
    ]
  },
  {
    id: 31,
    title: "TUFURAHINI",
    number: 31,
    verses: [
      "1. Tufurahini ulimwengu tumepata ukombozi tujapopata majaribu (Tenor: Eee) tazama msalaba hapo ndipo penye utakaso wa damu ya mwanakondoo",
      "CHORUS: (Bass) Majaribu.... Majaribu yetu yote hayana uwezo nazo shida zetu Zote zilishindwa kalwari",
      "2. Ni kwa vile ulimwenguni kote hapana jina jingine la kuleta ukombozi wala matumaini bali ni Yesu Kristo pekee aliye na uwezo.",
      "3. Furaha shangwe vigelele tukifika ngambo, macheo ya karibia, mawimbi ya tulia hatua kwa hatua tusonge hatuna kizuizi"
    ]
  },
  {
    id: 32,
    title: "JE NI NINI?",
    number: 32,
    verses: [
      "1. [Je ni nini?] kinakutenga na Bwana ndiyo hauwezi kumpa muda muda wako... (Sop) Je ni kazi au mali (All) Ndiyo kikwazo (Sop) Au ni uzembe wako (All) Ndiyo kikwazo... Badili mienendo yako ili tuingie kwetu juu mbinguni ×2",
      "Chorus: Jitayarishe ndugu usikose kuingia juu mbinguni...Kwenye harusi ya mwana kondoo. Mkombozi wetu wa pekee. Tutaimba wimbo mpya tukimsifu Mungu wetu... tutamsifu Mkombozi kwa furaha na amani. Vigelegele vitapigwa kwa shangwe na nderemo tukiingia juu mbinguni tuliko andaliwa makao.",
      "2. [Ndugu mpendwa] jitayarishe mwenzangu ili usikose kumwona Bwana wetu. (Sop) Wananjiwa tusikose (All) kuingia (Sop) Na ujira mkononi (All) Kuingia Tutasafiri na Bwana njooni tuingie kwetu juu mbinguni..."
    ]
  },
  {
    id: 33,
    title: "NAYERORIRE",
    number: 33,
    verses: [
      "1. Nayerorire ensoko engiya mono, n'ensok' entambe er' engare, baria bare nerang'o banyw' amach' aye, na abande basibigwe barabe pi, bacheneke korwa 'se 'bibe obogim' oboyia nabanyorex2",
      "CHORUS: Yeso ner' ensoko y'obogima, ere namache bono are moyo, kera oyokonywa takoba nerang'o, namoe obogima bwa kare na kare, ere negetare bono kiemiaka, ninchwo mwensi natwebise asare, amache na 'manyingaye, neriogo as' ebibe×2",
      "2. Ime ase ensoko barwaire bagwenigwa, basiru bonsi batoreka, emeuko barora, birema batara, abakwete babokigwa baba moyo, na 'bakungu abatomani banyor' okoborigwa ase ensoko×2"
    ]
  },
  {
    id: 34,
    title: "MSIWE KAMA MAFARISAYO",
    number: 34,
    verses: [
      "1) Msiwe Kama Mafarisayo wanaojipendekeza watazamwe. Utoapo zaka sipige panda kama wanafiki wafanyavyo. Msifanye vyema mtazamwe, kwa kufanya hivyo baraka hampati. Yeyote wa kiburi atashushwa bali mnyenyekevu atabarikiwa×2",
      "Chorus: Basi mbona wakitazama kibanzi kilicho ndani ya jicho langu. Na boriti iliyo ndani ya jicho lako hauoni. Ni wakati wa kujichunguza sio wakati wa kuchunguza mwenzako. Sote tumepungukiwa machoni pake na utukufu wa Mungu. ×2",
      "2) Unayedhani umesimama chunga sana ndugu usijeshushwa chini. Ufanyapo wema nenda zako, hakika taji la ajabu lakungoja. Kila jambo upimiacho mwenzako ndicho utakachopimiwa mwenzangu Wacha fitina kiburi na Masengenyo, hubiri leta wengi kwa zizi la bwana×2. *Ref: Matthew 7:1-5*"
    ]
  },
  {
    id: 35,
    title: "JAPO NI MACHAFUKO",
    number: 35,
    verses: [
      "1. Japo ni machafuko, zidisha imani ushindi bado upo kwani Mungu yupo. (×2)",
      "2. Majaribu yajayo, ni makubwa sana yataka imani kuu tuenzi na Yesu. (×2)",
      "3. Mpendwa wetu Yesu, ana nguvu nyingi amini mpaka mwisho atatuokoa. (×2)",
      "CHORUS: [ Solo: Amini] Amini. Amini......ingawa ni giza, (asubuhi) asubuhi karibu tutaifikia."
    ]
  },
  {
    id: 36,
    title: "LENGO LANGU",
    number: 36,
    verses: [
      "1. (Utakuwa wapi)...Utakuwa wapi siku Yesu arudipo, utakuwa mshindi au ni mshindwa. Je atakuja kama mhukumu wako au atakuwa mhukumu wako? akirudi [Akirudi] siku ile ya kiama.",
      "CHORUS: Lengo langu ni kumuona, (Yesu wangu....) ana kwa ana, atakapo nisimulia (kisa chote...) cha ukombozi tutembee naye taratibu, barabara zilizo dhahabu, (na sisi tule rojo) na tule rojo (rojo rojo...) zilizo mbinguni.",
      "2. Jitihada gani... (Jitihada gani) ndizo ndugu umefanya, ili kujiandaa kumlaki yesu... je uakesha na kudumu kwa maombi, au wasinzia kwenye imani.. Jiulize (jiulize...) uko upande gani"
    ]
  },
  {
    id: 37,
    title: "AMKA",
    number: 37,
    verses: [
      "1. (Amka angaza kwa wote wamwone) ... nuru yake iangaze kwa watu wote wamwone, nuru yake iangaze kwa watu wote wamwone.",
      "CHORUS: Kwenye milima, mabonde, iangaze nuru yake, wote wamwone, waje kwake.",
      "2. (Mwokozi karibu kurudi duniani) ... nuru yako iangaze kwa watu wote wamwone, nuriu yako iangaze wa watu wote wamwone."
    ]
  },
  {
    id: 38,
    title: "URAFIKI",
    number: 38,
    verses: [
      "1. [Urafiki wetu na bwana yesu *3] ni wa mda gani [alitupenda tangu uumbaji akatupenda tukiwa dhambini hadi kafa kifo juu ya msalaba upendo wake hauna kifani] *2",
      "CHORUS: Tufwate nyayo zake yesu kuelekwa kalivari ndipo penye wokovu wetu, unapopatikana hakuna njia ilo fupi ya kupata wokovu isopokuwa njia ile ya msalaba.",
      "2. [Maisha yako humu duniani *3] ni ya jinsi gani [je ni ulevi au ni usingizi? Je ni fitina au usherati? Je ni mchukizo mbele zake bwana au ni ya kumpendeza mungu] *2"
    ]
  },
  {
    id: 39,
    title: "SAFARI YETU",
    number: 39,
    verses: [
      "1. Safari yetu ya kwenda mbinguni imekuwa kweli ya ajabu, tutapitia na sayari mingi ikiwemo hata Zohari (tukiongozwa na malaika tutafika paradiso juu x2)",
      "CHORUS: Tutashangilia kwa vifijo, vigelegele na nderemo, tukifika huko juu mbinguni ni raha ya wateule. (Mbingu...) Mbingu yenye amani. (O mbingu..) mbingu yenye furaha (Mbingu..)Mbingu yenye raha tele, tuvumilie tufike mbingu.",
      "2. Tuachane na vikwazo vingi kama vile mali za dunia kwani zote zinafika mwisho, kwani zote zinatoweka (ndugu yangu tegemea Yesu yeye ndiye jawabu toshax2)"
    ]
  },
  {
    id: 40,
    title: "TANGAZA INJILI",
    number: 40,
    verses: [
      "1. Tangaza injili ya Bwana wote wasikie kila mmoja asikie apate uzima, kila mmoja asiie apate uzima.",
      "CHORUS: Njoo mwenzangu bwana akuita usisitesite ndugu Yesu akungoja tutakanyaga pole pole tukienda mbinguni",
      "2. Makao ya raha tayari yameandaliwa na wana huko hatutatengana tutakaa na bwana huko, hatutatengana tutakaa na bwana huko.",
      "3. Wito ni kwangu mi na wewe tuepuke na dunia ndipo tutavishwa taji tukiwa washidi, taji tukiwa washindi."
    ]
  },
  {
    id: 41,
    title: "SEMA SEMA",
    number: 41,
    verses: [
      "1. Sema sema dada sema ndugu sema sote sema juu ya Yesu, kila lugha pembe zote [msifu x5] Yesu. Aliyekufa kwa ajili yetu tuokolewe binadamu wa dhambi na pendo lake la zidi kipimo mkombozi wetu huyu Yesu.",
      "CHORUS: Jina lake huweza yote kwa Imani taja taja jina la Yesu Pepo hutoroka, magonjwa huponywa likiri likiri jina la hakika Umkubali maishani na ufaidike.",
      "2. Sema sema dada sema ndugu sema sote sema juu ya Yesu, injili yake eneza [kote x5] dunia nzima, hekima bure bure kakupa watoto bure na majumba makubwa uhai mali yote kakupa mkombozi wetu huyu Yesu."
    ]
  },
  {
    id: 42,
    title: "JINSI MUNGU",
    number: 42,
    verses: [
      "(Jinsi mungu alitupenda sisi tulipoanguka dhambini akatutolea kafara, mwake wa kipekee. Ili yeye amwamimiye yesu, naye asije kupotea bali na apate uzima, uzima wa milele x2) (Mchungaji mkuu ni Yesu, neno la uzimaa akafanyika mwanadamu akakaa kwetu x2)",
      "Kwa kifo na kufufuka kwake tunayo Imani ii, katuachia ahadi tamu tunayongojea aah Juu nyumbani mwa Baba yangu, Ni makao mengi ninanenda kuwaandaliaa kisha nitarudiix2",
      "(sop: Amka ndugu) machweo karibu. (sop & alto: Usizime taa yako) uwe na subira. (Tenor: Tazama mawinguni iii) atoka mbinguni (Bass: nasema sikiliza aa) atoka mbinguni x2"
    ]
  },
  {
    id: 43,
    title: "ULIMI",
    number: 43,
    verses: [
      "(Chunga ulimi wako utamkapo je ni kama mkristo x2) Ulimi moto mdogo uchomao msitu kubwa, Tena kiumbe kidogo chenye majivuno sana.",
      "(Ah ah ah lijueni hilo mtamkapo, muwe wenye busara, maneno yaletayo amani) x2",
      "SOLO: Hebu niwasimulieni mwanadamu ana uwezo wa kufuga wanyama wote, wa nchi na bahari. Na ulimi wake mwenyewe uovu usiotulia, Maneno yaleta maovu washindwa kuyafuga x2",
      "SOLO: Ndugu zangu yafaa nini, mtu asema wa Imani, lakini maneno maovu chuki na ukabila, chemichemi la jicho moja hayatoi maji matamu, Nayo yale maji machungu wajichocha mwenyewe x2"
    ]
  },
  {
    id: 44,
    title: "NI MUNGU GANI MTAKAYE ABUDU",
    number: 44,
    verses: [
      "1. Ni Mungu gani mtakaye abudu, hebu chagueni, Tulioponywa tutafuata nyayo zake mkombozi x2 (Wananjiwa)",
      "2. Ulinunuliwa kwa bei ghali hebu rudi kwa Yesu, kabla anga haijachafuka ndugu hebu toka Babeli x2",
      "CHORUS : Kama Danieli tutakataa ibada yake mfalme Dario, Wahibrania kwenye tanuru ya moto tutamfuata, simama kidete katika imani japo njia hii ni finyu, mwokozi alifuata papo hapo. Wananjiwa tutafuata nyayo zake mkombozi x2"
    ]
  },
  {
    id: 45,
    title: "KATIKA NEEMA",
    number: 45,
    verses: [
      "1. Katika neema ya Yesu nimeokolewa mimi mdhambi, niliyepotea dhambini kipofu rohoni neema ya Yesu yanitosha sana yafumbua macho na nikaona mwanga, Napata wokovu bure na ni huru sifa kwake Yesu, Amin x2",
      "2. Nilikuwa ni mwenye hofu nilifungwa na yule mwovu, sasa ni huru kwa neema ya mkombozi nitamsifu Bwana maishani mwote ushirika wangu na yeye msalabani nimekombolewa na sasa ni huru sifa kwake Yesu, Amin.",
      "3. Tutakapofika mbinguni nitamshukuru muumba wetu, kwa neema yake tumeshinda mauti ushindi tumepata furaha ajabu tutavikwa taji ya washindi naye Mungu, jitahidi ndugu ukamwone Yesu sifa kwake Yesu, Amin.",
      "CHORUS: Leo najivunia pendo la Yesu kwa neema yake aniweka huru, mimi siko chini ya dhambi nikiwa na Yesu, nitasonga mbele na nyuma kamwe, na hizo pepo za giza zitavunjwa, sifa kwake Yesu, Amin."
    ]
  },
  {
    id: 46,
    title: "MSIOGOPE",
    number: 46,
    verses: [
      "1. Msiogope nyi kundi ndogo Baba yenu aona [ona] hachoki kutushughulikia usiku mchana yeye halali, vaeni silaha zenu za vita muweni shujaa wa Imani tunapambana na falme za giza na pepo mbaya za ulimwengu.",
      "CHORUS: Tazama nimewapa mamlaka ya kukanyaga mapepo yote shetani hana mamlaka tena mkikiri jina lake Yesu na msonge mbele kwa ujasiri Yesu ni ngao milele zote.",
      "2. Pande zote tuna dhihikika lakini hatusongwi [kamwe] siku zote tutaona shaka lakini hatukati tama twaudhiwa bali hatuachwi twaona aibu na tukufu uwezo tumepewa na Bwana dunia tutashinda hakika."
    ]
  },
  {
    id: 47,
    title: "NDOA",
    number: 47,
    verses: [
      "1. Bwana ka agiza mume naye mke, wawe pamoja, waitunze ndoa yao kwa mapenzi teletele. Men: (Sharti mume apende mke wake...) Ladies: (Mke naye ampe heshima, mume wake x2)",
      "CHORUS: Ndoa ni takatifu, yahitaji uaminifu, na mapenzi teletele maombi yazidishwe, (ndoa iheshimiwe ni mpango wake) x2",
      "2. Mbona chuki na uzinzi katika ndoa iliyo safi, uaminifu na upendo ziwe nguzo dhabiti kwenye ndoa, (maombi upendo na idumu kweye ndoa yenu x2)"
    ]
  },
  {
    id: 48,
    title: "KIASI GANI",
    number: 48,
    verses: [
      "1. Kiasi gani watanga mbali na Bwana na umerushwarushwa huku na kule, Dunia imejaa mahangaiko mahangaiko taabu za maisha Rudi nyumbani rudi kwa Bwana unahangaika bure rudi nyumbani.",
      "Chorus: Rudi nyumbani rudi kwa Bwana sasa yatosha rudi nyumbani kuna mambo mazuri yanakungojea kivulini mwa Yesu kuna faraja nyumbani ni nyumbani utakuwa huru kuna sauti inakuita rudi nyumbani Bwana akwita.",
      "2. Dunia hii kuna mbwa mwitu wakali wasio na huruma wala hisani, walio tayari kukuangamize watakurarua wakuangamize, rudi nyumbani, mwanangu rudi, unahangaika bure rudi nyumbani."
    ]
  },
  {
    id: 49,
    title: "MASICHE DUTO",
    number: 49,
    verses: [
      "1. Masiche duto donge nyisowa ni Yesu duogo watimuru kinda , Mondo kobiro wadonji kode , Nobed mor maduong' kawaneno Ruodhwa  x2",
      "Chorus: Masiche lwenje opong'o  pinywani Tuoche gi thoe be opong'o piny Mwandu mawango kalo kaka yamo Yesu wakwayi mondo itelnwa x2",
      "2. Tomagi duto yango giko piny , Magi ranyisi ndalo mag giko, Omiyo ringuru wadhi ire, Nikech kuom yesu geno nitiere x2"
    ]
  },
  {
    id: 50,
    title: "PENDO LA YESU",
    number: 50,
    verses: [
      "1. Bwana Mungu nakushukuru, umenitendea mambo makuu sana, nilipotea na kuzama katika shimo la dhambi, lakini kwa upendo wako, umenikomboa Yesu, na kunifanya kuwa mwana wako tena",
      "Chorus: Ni pendo la Yesu pendo la agape lilinitafuta nilipopotea, ningependa kuwa bawabu nyumbani mwa Bwana na kulitukuza jina lake milele, tusifarakane nafsi na kurudi nyuma tuvumilie miguuni pa Yesu",
      "2. Kwako nitatia nanga, jua la utosi limekwisha choma, gongo na fimbo lanifariji Bwana nasitirika kwako, Bwana wewe mlinzi wangu majani mabichi hunilaza na kuninywesha maji yale matulivu"
    ]
  },
  {
    id: 51,
    title: "MEFIBOSHETHI",
    number: 51,
    verses: [
      "1.Je, amesalia mtu mmoja katika nyumba ya Sauli...? Daudi kauliza apate kumtendea mema kwa ajili ya Yonathani, naye Siba kamjibu kamwambia Kuna yule Mefiboshethi aliyelemaa mguu wake kule Lodebarix2",
      "Chorus: Neema yake Mungu kwetu ni Bure tazameni msalaba, tokeni mjini Lodebari Rudi Zizini mwake, na tusiogope atatuonyesha fadhili za upendo wake na tukitazama msalaba wa Yesu tutapata badiliko×2",
      "2. Mefiboshethi mwana wa Yonathani akaenda kwake Daudi mbele yake mfalme kaanguka kifudifudi akaanza kusujudu ndipo mfalme kamtendea mema kwa ajili ya Yonathani kampa uwezo wa kushiriki meza pamoja naye daima×2"
    ]
  },
  {
    id: 52,
    title: "KAMWE USIONDOKE",
    number: 52,
    verses: [
      "1. Kamwe kamwe usiondoke yerusalemi maana hapa ni pa utulivu na usalama, siku utakapo ondoka, ondoka utaangamia",
      "CHORUS: miguuni pake yesu pa utulivu penye mazuri tulia, hapo ndipo penye upendo penye furaha tulia, dhambi zako zisikuondoe yerusalemi",
      "2. solo: Aliambia Shimei usiondoke Yerusalemi, jenga jenga nyumba yako ukae pa utulivu, [utakapo ondoka utaangamia]"
    ]
  },
  {
    id: 53,
    title: "SIMAMA IMARA",
    number: 53,
    verses: [
      "CHORUS: [simama] Simama imara jilinde, neno lake Bwana imara, kesha kila siku uombe [uombe] litasimama",
      "1. Milima yote na mabonde, itayeyuka neno lake Bwana imara, litasimama",
      "2. Katika yote tutashinda kwa nguvu yake, nani aweza kututenga na pendo lake.",
      "3. Afikapo Bwana harusi, tayarisha taa nenda kumlaki kwa shangwe njoo kwake leo."
    ]
  },
  {
    id: 54,
    title: "LAODEKIA",
    number: 54,
    verses: [
      "1. Ewe kanisa laodekia, nimesikia habari zako, wewe si mmoto na tena wewe si mbaridi,( kwa hivyo basi nitakutema toka kinywani mwangu ewe mnafiki )×2",
      "Chorus: Unafiki na uongo umetulemea sisi wa kristo hatusemi ukweli, tukiwa kwa wakristo sisi tu wakristo, tukiwa pekee yetu sisi wenye dhambi, (tubadilishe mienendo yetu tuwe wakamilifu)×2",
      "2.Waliyanena sikio la kufa halisiki dawa, aliyechagua kifo ataangamia, imarisha Imani yako husikose ufalme wake, (usikuwe Kama kambezi, aliyechagua kifo)×2"
    ]
  },
  {
    id: 55,
    title: "NENO MOJA",
    number: 55,
    verses: [
      "1. Neno Moja nimelitaka kwa Bwana wangu nalo ndilo nitakalolitafuta, nikae nyumbani mwa baba yangu siku zote za maisha yangu, (niutazame: unison) uzuri wake kila siku na kutafakari hekaluni mwake ×2",
      "Chorus: Nitakushuru Kwa unyofu wa moyo wako, nikiisha kujifunza ukuu wa hako yako, nitazitii amri zako bwana, usiniache kamwe nakutegemea ×2.",
      "2. SOLO:"
    ]
  },
  {
    id: 56,
    title: "WIMBO MZURI",
    number: 56,
    verses: [
      "1. Ninao wimbo mzuri sikiliza, wimbo wa Musa na mwanakondoo. Wimbo mtamu wimbo wa wateule, hata masikio hayajasikia. Makerubi wote na Maserafi, watatulaki kwa wimbo huo. Kwa uwezo wa Bwana tutaimba, wimbo mtamu wa washindi.",
      "CHORUS: Wimbo mtamu, wimbo safi, tutaimba, naye Yesu na kila pembe za dunia tutakutana angani. Hata vinubi zeze zitapigwa, tukimwabudu kwa heshima, itakuwa furaha bila kipimo, milele na milele.",
      "2. Kama nyota taji zetu zitang'aa hakuna huzuni wala upweke, maombolezo na dhiki za dunia hapatikani ukumbini mwa Bwana, naye Yesu atafunza wimbo mpya kazi zetu ni kuimba imba tu. Sauti zetu zitakuwa nyororo, wimbo mzuri wa washindi."
    ]
  }
];

const Hymns = () => {
  const { currentUser } = useAuth();
  const { showToast } = useToast();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedHymn, setSelectedHymn] = useState(null);
  const [showHymnDialog, setShowHymnDialog] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [recentlyViewed, setRecentlyViewed] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [fontSize, setFontSize] = useState(16);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  // Load favorites from Firestore
  useEffect(() => {
    const loadFavorites = async () => {
      if (!currentUser) {
        setFavorites([]);
        setLoading(false);
        return;
      }

      try {
        const userRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userRef);
        
        if (userDoc.exists() && userDoc.data().favoriteHymns) {
          setFavorites(userDoc.data().favoriteHymns);
        }
        
        // Load recently viewed from localStorage
        const savedRecently = localStorage.getItem('recentlyViewedHymns');
        if (savedRecently) {
          setRecentlyViewed(JSON.parse(savedRecently));
        }
      } catch (error) {
        console.error('Error loading favorites:', error);
      } finally {
        setLoading(false);
      }
    };

    loadFavorites();
  }, [currentUser]);

  // Toggle favorite
  const toggleFavorite = async (hymnId) => {
    if (!currentUser) {
      showToast('Please login to save favorites', 'warning');
      return;
    }

    try {
      const userRef = doc(db, 'users', currentUser.uid);
      const isFavorite = favorites.includes(hymnId);
      
      if (isFavorite) {
        await updateDoc(userRef, {
          favoriteHymns: arrayRemove(hymnId)
        });
        setFavorites(favorites.filter(id => id !== hymnId));
        showToast('Removed from favorites', 'success');
      } else {
        await updateDoc(userRef, {
          favoriteHymns: arrayUnion(hymnId)
        });
        setFavorites([...favorites, hymnId]);
        showToast('Added to favorites', 'success');
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
      showToast('Error updating favorites', 'error');
    }
  };

  // Add to recently viewed
  const addToRecentlyViewed = (hymnId) => {
    const updated = [hymnId, ...recentlyViewed.filter(id => id !== hymnId)].slice(0, 20);
    setRecentlyViewed(updated);
    localStorage.setItem('recentlyViewedHymns', JSON.stringify(updated));
  };

  // Handle hymn selection
  const handleHymnSelect = (hymn) => {
    setSelectedHymn(hymn);
    setShowHymnDialog(true);
    addToRecentlyViewed(hymn.id);
  };

  // Filter hymns
  const filteredHymns = useMemo(() => {
    if (!searchTerm) return hymnsData;
    
    const searchLower = searchTerm.toLowerCase();
    return hymnsData.filter(hymn => 
      hymn.title.toLowerCase().includes(searchLower) ||
      hymn.number.toString().includes(searchLower) ||
      hymn.verses.some(v => v.toLowerCase().includes(searchLower))
    );
  }, [searchTerm]);

  // Get hymns for current tab
  const getCurrentHymns = () => {
    switch(activeTab) {
      case 0: return filteredHymns;
      case 1: return hymnsData.filter(h => favorites.includes(h.id));
      case 2: return hymnsData.filter(h => recentlyViewed.includes(h.id));
      default: return filteredHymns;
    }
  };

  const currentHymns = getCurrentHymns();

  // Hymn Card Component
  const HymnCard = ({ hymn }) => {
    const isFavorite = favorites.includes(hymn.id);
    
    return (
      <Card 
        className={`hymn-card ${isDarkMode ? 'dark' : ''}`}
        onClick={() => handleHymnSelect(hymn)}
        sx={{ 
          cursor: 'pointer',
          transition: 'all 0.3s',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: 3
          }
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
              <Typography variant="caption" color="textSecondary">
                #{hymn.number}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 0.5 }}>
                {hymn.title}
              </Typography>
            </Box>
            <IconButton 
              size="small" 
              onClick={(e) => {
                e.stopPropagation();
                toggleFavorite(hymn.id);
              }}
              color={isFavorite ? 'error' : 'default'}
            >
              {isFavorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
            </IconButton>
          </Box>
          <Typography 
            variant="body2" 
            color="textSecondary"
            sx={{ 
              mt: 1,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {hymn.verses[0]?.substring(0, 100)}...
          </Typography>
          <Box sx={{ mt: 1, display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
            <Chip 
              size="small" 
              label={`${hymn.verses.length} verses`} 
              variant="outlined"
            />
          </Box>
        </CardContent>
      </Card>
    );
  };

  return (
    <Box className={`hymns-container ${isDarkMode ? 'dark-mode' : ''}`}>
      {/* Header */}
      <Box className="hymns-header">
        <Typography variant="h4" component="h1" sx={{ color: '#1034A6', fontWeight: 'bold' }}>
          <MusicNoteIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
        WHITE DOVES SONGS
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {hymnsData.length} Hymns • {favorites.length} Favorites
        </Typography>
      </Box>

      {/* Search Bar */}
      <Box className="hymns-search">
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search hymns by title, number, or lyrics..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setSearchTerm('')}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </Box>

      {/* Tabs */}
      <Tabs 
        value={activeTab} 
        onChange={(e, v) => setActiveTab(v)}
        sx={{ mb: 3 }}
        variant={isMobile ? 'scrollable' : 'fullWidth'}
        scrollButtons={isMobile ? 'auto' : false}
      >
        <Tab icon={<MenuBookIcon />} label="All Hymns" />
        <Tab 
          icon={<FavoriteIcon />} 
          label="Favorites" 
          iconPosition="start"
          badge={favorites.length > 0 ? favorites.length : null}
        />
        <Tab icon={<HistoryIcon />} label="Recent" />
      </Tabs>

      {/* Hymns Grid */}
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      ) : currentHymns.length === 0 ? (
        <Box className="empty-state">
          <LibraryIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
          <Typography variant="h6">
            {activeTab === 0 ? 'No hymns found' : 
             activeTab === 1 ? 'No favorites yet' : 
             'No recently viewed hymns'}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {activeTab === 0 ? 'Try adjusting your search' : 
             activeTab === 1 ? 'Start adding hymns to your favorites' : 
             'Start viewing hymns'}
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {currentHymns.map(hymn => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={hymn.id}>
              <HymnCard hymn={hymn} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* Hymn Detail Dialog */}
      <Dialog 
        open={showHymnDialog} 
        onClose={() => setShowHymnDialog(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          className: `hymn-dialog ${isDarkMode ? 'dark' : ''}`
        }}
      >
        {selectedHymn && (
          <>
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    #{selectedHymn.number}
                  </Typography>
                  <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                    {selectedHymn.title}
                  </Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => toggleFavorite(selectedHymn.id)} color={favorites.includes(selectedHymn.id) ? 'error' : 'default'}>
                    {favorites.includes(selectedHymn.id) ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                  </IconButton>
                  <IconButton onClick={() => setShowHymnDialog(false)}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent dividers>
              <Box className="hymn-content">
                <Box className="hymn-controls" sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => setFontSize(Math.max(12, fontSize - 2))}
                    disabled={fontSize <= 12}
                  >
                    A-
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => setFontSize(Math.min(24, fontSize + 2))}
                    disabled={fontSize >= 24}
                  >
                    A+
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => setIsDarkMode(!isDarkMode)}
                  >
                    {isDarkMode ? '☀️ Light' : '🌙 Dark'}
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      window.print();
                    }}
                  >
                    <PrintIcon fontSize="small" sx={{ mr: 0.5 }} /> Print
                  </Button>
                </Box>
                
                <Box sx={{ fontSize: fontSize, lineHeight: 1.8 }}>
                  {selectedHymn.verses.map((verse, index) => (
                    <Typography 
                      key={index} 
                      paragraph
                      sx={{ 
                        whiteSpace: 'pre-wrap',
                        fontFamily: isDarkMode ? 'inherit' : 'Georgia, serif',
                        fontSize: verse.toUpperCase().includes('CHORUS') ? fontSize * 1.1 : fontSize,
                        fontWeight: verse.toUpperCase().includes('CHORUS') ? 'bold' : 'normal',
                        color: verse.toUpperCase().includes('CHORUS') ? '#1034A6' : 'inherit'
                      }}
                    >
                      {verse}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowHymnDialog(false)}>Close</Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default Hymns;
